module.exports = require("@swa-ui/core/src/Toast/Toast.module.scss");